//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.15.10.0 (NJsonSchema v10.6.10.0 (Newtonsoft.Json v11.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

export class Client {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param key (optional) 
     * @return OK
     */
    invoices(key: string | undefined): Promise<Invoice> {
        let url_ = this.baseUrl + "/Invoices?";
        if (key === null)
            throw new Error("The parameter 'key' cannot be null.");
        else if (key !== undefined)
            url_ += "key=" + encodeURIComponent("" + key) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processInvoices(_response);
        });
    }

    protected processInvoices(response: Response): Promise<Invoice> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Invoice.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Invoice>(null as any);
    }

    /**
     * @param token (optional) 
     * @param body (optional) 
     * @return OK
     */
    pay(token: string | undefined, body: string[] | undefined): Promise<PaymentResponse> {
        let url_ = this.baseUrl + "/Invoices/Pay?";
        if (token === null)
            throw new Error("The parameter 'token' cannot be null.");
        else if (token !== undefined)
            url_ += "token=" + encodeURIComponent("" + token) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processPay(_response);
        });
    }

    protected processPay(response: Response): Promise<PaymentResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaymentResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaymentResponse>(null as any);
    }

    /**
     * @param secret (optional) 
     * @return OK
     */
    downloadReceipt(secret: string | undefined): Promise<void> {
        let url_ = this.baseUrl + "/Invoices/DownloadReceipt?";
        if (secret === null)
            throw new Error("The parameter 'secret' cannot be null.");
        else if (secret !== undefined)
            url_ += "secret=" + encodeURIComponent("" + secret) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDownloadReceipt(_response);
        });
    }

    protected processDownloadReceipt(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param email (optional) 
     * @param secret (optional) 
     * @return OK
     */
    sendEmailReceipt(email: string | undefined, secret: string | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/Invoices/SendEmailReceipt?";
        if (email === null)
            throw new Error("The parameter 'email' cannot be null.");
        else if (email !== undefined)
            url_ += "email=" + encodeURIComponent("" + email) + "&";
        if (secret === null)
            throw new Error("The parameter 'secret' cannot be null.");
        else if (secret !== undefined)
            url_ += "secret=" + encodeURIComponent("" + secret) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSendEmailReceipt(_response);
        });
    }

    protected processSendEmailReceipt(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }
}

export class Invoice implements IInvoice {
    invoiceNumber?: string | undefined;
    paid?: boolean | undefined;
    outstandingAmount?: number | undefined;

    constructor(data?: IInvoice) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.invoiceNumber = _data["invoiceNumber"];
            this.paid = _data["paid"];
            this.outstandingAmount = _data["outstandingAmount"];
        }
    }

    static fromJS(data: any): Invoice {
        data = typeof data === 'object' ? data : {};
        let result = new Invoice();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["invoiceNumber"] = this.invoiceNumber;
        data["paid"] = this.paid;
        data["outstandingAmount"] = this.outstandingAmount;
        return data;
    }
}

export interface IInvoice {
    invoiceNumber?: string | undefined;
    paid?: boolean | undefined;
    outstandingAmount?: number | undefined;
}

export class InvoiceResponse implements IInvoiceResponse {
    invoiceNumber?: string | undefined;
    amount?: number | undefined;
    exclAmount?: number | undefined;
    taxAmount?: number | undefined;

    constructor(data?: IInvoiceResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.invoiceNumber = _data["invoiceNumber"];
            this.amount = _data["amount"];
            this.exclAmount = _data["exclAmount"];
            this.taxAmount = _data["taxAmount"];
        }
    }

    static fromJS(data: any): InvoiceResponse {
        data = typeof data === 'object' ? data : {};
        let result = new InvoiceResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["invoiceNumber"] = this.invoiceNumber;
        data["amount"] = this.amount;
        data["exclAmount"] = this.exclAmount;
        data["taxAmount"] = this.taxAmount;
        return data;
    }
}

export interface IInvoiceResponse {
    invoiceNumber?: string | undefined;
    amount?: number | undefined;
    exclAmount?: number | undefined;
    taxAmount?: number | undefined;
}

export class PaymentResponse implements IPaymentResponse {
    createdAt?: string | undefined;
    merchantCode?: string | undefined;
    customerCode?: string | undefined;
    token?: string | undefined;
    ip?: string | undefined;
    amount?: number | undefined;
    currency?: string | undefined;
    status?: string | undefined;
    orderId?: string | undefined;
    bankTransactionId?: string | undefined;
    gatewayResponseCode?: string | undefined;
    gatewayResponseMessage?: string | undefined;
    errorCode?: string | undefined;
    rawResponse?: string | undefined;
    invoiceResponses?: InvoiceResponse[] | undefined;
    secret?: string | undefined;

    constructor(data?: IPaymentResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.createdAt = _data["createdAt"];
            this.merchantCode = _data["merchantCode"];
            this.customerCode = _data["customerCode"];
            this.token = _data["token"];
            this.ip = _data["ip"];
            this.amount = _data["amount"];
            this.currency = _data["currency"];
            this.status = _data["status"];
            this.orderId = _data["orderId"];
            this.bankTransactionId = _data["bankTransactionId"];
            this.gatewayResponseCode = _data["gatewayResponseCode"];
            this.gatewayResponseMessage = _data["gatewayResponseMessage"];
            this.errorCode = _data["errorCode"];
            this.rawResponse = _data["rawResponse"];
            if (Array.isArray(_data["invoiceResponses"])) {
                this.invoiceResponses = [] as any;
                for (let item of _data["invoiceResponses"])
                    this.invoiceResponses!.push(InvoiceResponse.fromJS(item));
            }
            this.secret = _data["secret"];
        }
    }

    static fromJS(data: any): PaymentResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PaymentResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["createdAt"] = this.createdAt;
        data["merchantCode"] = this.merchantCode;
        data["customerCode"] = this.customerCode;
        data["token"] = this.token;
        data["ip"] = this.ip;
        data["amount"] = this.amount;
        data["currency"] = this.currency;
        data["status"] = this.status;
        data["orderId"] = this.orderId;
        data["bankTransactionId"] = this.bankTransactionId;
        data["gatewayResponseCode"] = this.gatewayResponseCode;
        data["gatewayResponseMessage"] = this.gatewayResponseMessage;
        data["errorCode"] = this.errorCode;
        data["rawResponse"] = this.rawResponse;
        if (Array.isArray(this.invoiceResponses)) {
            data["invoiceResponses"] = [];
            for (let item of this.invoiceResponses)
                data["invoiceResponses"].push(item.toJSON());
        }
        data["secret"] = this.secret;
        return data;
    }
}

export interface IPaymentResponse {
    createdAt?: string | undefined;
    merchantCode?: string | undefined;
    customerCode?: string | undefined;
    token?: string | undefined;
    ip?: string | undefined;
    amount?: number | undefined;
    currency?: string | undefined;
    status?: string | undefined;
    orderId?: string | undefined;
    bankTransactionId?: string | undefined;
    gatewayResponseCode?: string | undefined;
    gatewayResponseMessage?: string | undefined;
    errorCode?: string | undefined;
    rawResponse?: string | undefined;
    invoiceResponses?: InvoiceResponse[] | undefined;
    secret?: string | undefined;
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}